module.exports = __webpack_public_path__ + "static/media/Upload-images.b3365a4d.svg";